import { Trophy as TrophyIcon } from 'lucide-react'
import type { OriginalTrophy } from '@/api/trophies'

// レア度(1-10)ごとの色。5帯にまとめる（銅→銀→金→青→伝説）
// 同ファイルに表示用コンポーネントを同居させているための例外（共有ヘルパー）
// eslint-disable-next-line react-refresh/only-export-components
export function tierStyle(rarity: number): { color: string; glow: string } {
  if (rarity >= 9) return { color: '#b06bf0', glow: 'rgba(176,107,240,.6)' }
  if (rarity >= 7) return { color: '#34d3e0', glow: 'rgba(52,211,224,.5)' }
  if (rarity >= 5) return { color: '#f5b942', glow: 'rgba(245,185,66,.55)' }
  if (rarity >= 3) return { color: '#aab2bd', glow: 'rgba(192,200,210,.5)' }
  return { color: '#cd7f32', glow: 'rgba(205,127,50,.45)' }
}

/** 棚に乗るトロフィー像（表示専用・タップ等は親が処理） */
export function TrophyFigure({ trophy }: { trophy: OriginalTrophy }) {
  const { color, glow } = tierStyle(trophy.rarity)
  return (
    <div className="pointer-events-none flex flex-col items-center justify-end gap-0.5">
      <TrophyIcon
        size={36}
        style={{ color, filter: `drop-shadow(0 0 6px ${glow})`, strokeWidth: 1.75 }}
      />
      <span className="line-clamp-2 text-center text-[10px] font-medium leading-tight">
        {trophy.name}
      </span>
    </div>
  )
}

/** 空の台座（編集時の追加枠） */
export function EmptyPedestal({ editable }: { editable?: boolean }) {
  return (
    <div className="pointer-events-none flex h-full w-full flex-col items-end justify-end pb-1">
      <div className="mx-auto flex h-9 w-9 items-center justify-center rounded-full border border-dashed border-primary/50 text-primary/50">
        {editable && <span className="text-base leading-none">＋</span>}
      </div>
    </div>
  )
}

/** 木の棚板 */
export function ShelfBoard() {
  return (
    <div
      className="h-2.5 rounded-[2px]"
      style={{
        background: 'linear-gradient(180deg,#a06a3c 0%,#8a572f 55%,#6d4423 100%)',
        boxShadow: '0 3px 5px -1px rgba(0,0,0,.35), inset 0 1px 0 rgba(255,255,255,.25)',
      }}
    />
  )
}

/** 読み取り専用グリッド（3列・棚板付き）。フレンドの棚などで使用 */
export function StaticShelf({
  items,
  onTap,
}: {
  items: OriginalTrophy[]
  onTap: (t: OriginalTrophy) => void
}) {
  const rows: OriginalTrophy[][] = []
  for (let i = 0; i < items.length; i += 3) rows.push(items.slice(i, i + 3))

  return (
    <div className="space-y-1">
      {rows.map((row, i) => (
        <div key={i}>
          <div className="grid min-h-[74px] grid-cols-3 items-end gap-1 px-2 pb-1">
            {row.map((t) => (
              <button key={t.id} type="button" onClick={() => onTap(t)} className="h-full">
                <TrophyFigure trophy={t} />
              </button>
            ))}
          </div>
          <ShelfBoard />
        </div>
      ))}
    </div>
  )
}
